import React from "react";
import DOMPurify from "dompurify";

type SafeHtmlProps<Tag extends keyof JSX.IntrinsicElements> = {
  html: string;
  as?: Tag;
} & Omit<JSX.IntrinsicElements[Tag], "dangerouslySetInnerHTML" | "children">;

const SafeHtml = <Tag extends keyof JSX.IntrinsicElements = "div">(
  props: SafeHtmlProps<Tag>
) => {
  const { html, as = "div", ...rest } = props;
  const sanitizedHtml = DOMPurify.sanitize(html ?? "", {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
      "allow",
      "allowfullscreen",
      "frameborder",
      "scrolling",
      "src",
      "height",
      "width",
      "title",
      "loading",
      "referrerpolicy"
    ]
  });

  return React.createElement(as, {
    ...rest,
    dangerouslySetInnerHTML: { __html: sanitizedHtml }
  });
};

export default SafeHtml;